import { type GalleryGroupType } from '@/defs/gallery'
import { type RecRoleType } from '@/defs/rec'

import { getFilteredGallery, type Props as FilterProps } from './getFilteredGallery'
import { getGalleryGroups, type Props as GroupProps } from './getGalleryGroups'
import { getSortedGallery, type Props as SortProps } from './getSortedGallery'

type Props = GroupProps & SortProps & FilterProps

type ResultsResponseType = {
  filteredCount: number
  groups: GalleryGroupType[]
  hasMultipleRoles: boolean
  recsCount: number
  role?: RecRoleType
  roles: RecRoleType[]
}

export const getGalleryResults = (props: Props): ResultsResponseType => {
  const { filteredCount, recs, recsCount } = getFilteredGallery(props)

  const { groups, hasMultipleRoles, role, roles } = getGalleryGroups({ ...props, recs })

  return {
    filteredCount,
    groups: groups.map(({ recs, ...group }) => ({
      ...group,
      recs: getSortedGallery({ ...props, recs }),
    })),
    hasMultipleRoles,
    recsCount,
    role,
    roles,
  }
}
